export const UnitMeasurement = {
  UNIT: 'unit',
  BU: 'bu',
  L: 'l',
  TON: 'ton',
  KG: 'kg',
  L_HA: 'l_ha',
  KG_HA: 'kg_ha',
  L_S: 'l/s',
  MQ_H: 'm³/h',
  L_MIN: 'l/min',
  L_H: 'l/h',
  MM: 'mm',
  kg_animal: 'kg_animal',
  g_animal: 'g_animal',
  mg_animal: 'mg_animal',
  l_animal: 'l_animal',
  unit_animal: 'unit_animal',
  MC: 'm3',
  Q: 'q',
  T: 't',
  HL: 'hl',
};
